module.exports = __webpack_public_path__ + "img/zoom-light.d8027f87.svg";